import React from "react";
import { MdCardGiftcard } from "react-icons/md";

import styles from "./BonusEarnInfo.module.scss";

interface Props {
  earned: number;
  percent: number;
}

export const BonusEarnInfo: React.FC<Props> = ({ earned, percent }) => {
  if (earned === 0) return null;

  return (
    <div className={styles.Container}>
      <div className={styles.Icon}>
        <MdCardGiftcard size={18} />
      </div>

      <div className={styles.Content}>
        <span className={styles.Title}>Кешбэк за заказ</span>
        <div className={styles.ValueRow}>
          <span className={styles.Value}>+{earned} ₽</span>
          <span className={styles.Percent}>{percent}%</span>
        </div>
      </div>
    </div>
  );
};